<template>
    <div class="profile" v-if="label">
        <!-- Mobile, tablet -->
        <div class="menu-mobile" v-if="windowWidth <= 1080">
          <label class="label">{{label.titles.navigation}}</label>
          <div class="control">
            <div class="dropdown" :class="{'is-active': profileDropActive}">
              <div class="dropdown-trigger">
                <button
                  class="button"
                  type="button"
                  @click="profileDropActive = !profileDropActive"
                  @blur="profileDropActive = false">
                  <span>{{profileText}}</span>
                  <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                </button>
              </div>
              <div class="dropdown-menu " role="menu">
                <div class="dropdown-content">
                  <a class="dropdown-item" @mousedown="$router.push('/profile/infos', () => {})">{{label.buttons.infos}}</a>
                  <a class="dropdown-item" @mousedown="$router.push('/profile/addresses', () => {})">{{label.buttons.addresses}}</a>
                  <a class="dropdown-item" @mousedown="$router.push('/profile/pods', () => {})">{{label.buttons.pods}}</a>
                  <a class="dropdown-item" @mousedown="$router.push('/profile/consumptions', () => {})">{{label.buttons.consumptions}}</a>
                  <a class="dropdown-item" @mousedown="$router.push('/profile/indexes', () => {})">{{label.buttons.indexes}}</a>
                  <!-- <a class="dropdown-item" @mousedown="$router.push('/profile/alerts', () => {})">{{label.buttons.myAlerts}}</a> -->
                  <a class="dropdown-item" @mousedown="$router.push('/profile/events', () => {})">{{label.buttons.myEvents}}</a>
                  <!-- <a class="dropdown-item" @mousedown="$router.push('/profile/spends', () => {})">{{label.buttons.mySpends}}</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <aside class="menu" v-else>
          <p class="menu-label">
            {{label.titles.technical}}
          </p>
          <ul class="menu-list">
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/infos'}" to="/profile/infos">{{label.buttons.infos}}</router-link></li>
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/addresses'}" to="/profile/addresses">{{label.buttons.addresses}}</router-link></li>
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/pods'}" to="/profile/pods">{{label.buttons.pods}}</router-link></li>
          </ul>

          <p class="menu-label">
            {{label.titles.consumptions}}
          </p>
          <ul class="menu-list">
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/consumptions'}" to="/profile/consumptions">{{label.buttons.consumptions}}</router-link></li>
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/indexes'}" to="/profile/indexes">{{label.buttons.indexes}}</router-link></li>
          </ul>

          <p class="menu-label">
            {{label.titles.events}}
          </p>
          <ul class="menu-list">
            <!-- <li><router-link :class="{ 'is-active': this.$route.path == '/profile/alerts'}" to="/profile/alerts">{{label.buttons.myAlerts}}</router-link></li> -->
            <li><router-link :class="{ 'is-active': this.$route.path == '/profile/events'}" to="/profile/events">{{label.buttons.myEvents}}</router-link></li>
            <!-- <li><router-link :class="{ 'is-active': this.$route.path == '/profile/spends'}" to="/profile/spends">{{label.buttons.mySpends}}</router-link></li> -->
          </ul>
        </aside>

        <div class="profile-content box">
          <router-view />
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      profileDropActive: false
    }
  },
  computed: {
    ...mapState({ label: state => state.labels.profile }),
    profileText() {
      let routeName = this.$route.path.replace("/profile/", "")
      if (["alerts", "events", "spends"].includes(routeName)) {
        return this.label.buttons[`my${routeName[0].toUpperCase()}${routeName.substring(1)}`]
      } else {
        return this.label.buttons[routeName]
      }
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"])
  },
  created() {
    this.windowWidth = window.innerWidth
    if (this.$route.path === '/profile') this.$router.push("/profile/infos", () => {});
    this.getLabel({ view: 'profile' })
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
.profile {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  grid-template-rows: minmax(calc(100vh - 71.99px), min-content);

  &-content {
    margin: 40px 40px auto 40px;
    padding: 40px;
  }
}

@media screen and (max-width: 1080px) {
  .profile {
    display: flex;
    flex-direction: column;

    &-content {
      margin: 0;
    }
  }
}

.is-active {
  border-radius: 4px;
  background-color: #8796c9 !important;
}

.menu {
  background-color: white;
  padding: 20px;

  &-mobile {
    margin: 1rem auto;
  }
}
</style>